import { Dispatch, SetStateAction, useMemo } from "react"
import { Box } from "@mui/material"
import NoTestResults from "./components/NoTestResults"
import TestResults from "./components/TestResults"
import { DisplayResultsBy, OpenLogResultModal, Room, WaterlineItem, WaterlineTestResult } from "./types"

type WaterlineTestResults = {
  rooms: Room[],
  testResults: WaterlineTestResult[],
  inventoryItems: WaterlineItem[],
  displayResultsBy: DisplayResultsBy,
  getCompliance: () => Promise<void>,
  getTestResults: () => Promise<void>,
  setTabIndex: Dispatch<SetStateAction<number>>,
  setOpenModal: Dispatch<SetStateAction<OpenLogResultModal>>,
  setDisplayResultsBy: Dispatch<SetStateAction<DisplayResultsBy>>,
}

const WaterlineTestResults = (props: WaterlineTestResults) => {
  const {
    rooms,
    testResults,
    inventoryItems,
    displayResultsBy,
    getCompliance,
    getTestResults,
    setTabIndex,
    setOpenModal,
    setDisplayResultsBy,
  } = props

  const hasInOfficeTesting = useMemo(() => {
    return inventoryItems.some(inventoryItem => {
      const subCategory = inventoryItem?.subcategory?.toLowerCase()
      return subCategory === 'in-office'
    })
  }, [inventoryItems])  



  return (
    <Box>
      {
        testResults.length === 0 && (
          <NoTestResults
            setOpenModal={setOpenModal}
            hasInOfficeTesting={hasInOfficeTesting}
          />
        )
      }
      {
        Boolean(testResults.length) && (
          <TestResults
            rooms={rooms}
            testResults={testResults}
            displayResultsBy={displayResultsBy}
            hasInOfficeTesting={hasInOfficeTesting}
            getCompliance={getCompliance}
            getTestResults={getTestResults}
            setTabIndex={setTabIndex}
            setOpenModal={setOpenModal}
            setDisplayResultsBy={setDisplayResultsBy}
          />
        )        
      }
    </Box>
  )
}

export default WaterlineTestResults
